// extracted by mini-css-extract-plugin
export var main = "_3d536a71c9428d34c13a3684502d2974-css";